import React, { FC } from "react";
import styles from "./Navbar.module.css";
import { motion } from "framer-motion";

const Navbar: FC = () => {
  return (
    <motion.nav
      id="navbar"
      className={styles.container}
      initial={{
        y: -250,
      }}
      animate={{
        y: 2,
      }}
      transition={{
        delay: 0.5,
        type: "spring",
      }}
    >
      <div className={styles.left}>
        <h1>Anton Jeejo</h1>
      </div>
      <ul className={styles.center}>
        <li>
          <a href="#home">Home </a>
        </li>
        <li>
          <a href="#about">About </a>
        </li>
        <li>
          <a href="#exp">Experience </a>
        </li>
        <li>
          <a href="#projects">Projects </a>
        </li>
        <li>
          <a href="#testimonials">Testimonials </a>
        </li>
      </ul>
      <div className={styles.right}>
        <button>
          <a href="#contact">Contact Me</a>
        </button>
      </div>
    </motion.nav>
  );
};

export default Navbar;
